export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_03.8e3664d7.jpg";